module.exports = __webpack_public_path__ + "img/pp-34.fd1012d1.jpg";